<template>
    <div class="product-not-available">
        <form @submit.prevent="handlerSubmit" class="product-not-available-form">
          <MaskInput
              ref="phone"
              class="phone"
              name="phone"
              mask="+38 (0##) ###-##-##"
              v-model="phone"
              type="text"
              @change.native="phoneEror=false"
              :masked="true"
              placeholder="+38 (0__) ___-__-__"
              autocomplete="off"
          />
            <DefButtonPrimary type="submit">
              {{params.submit}}
            </DefButtonPrimary>
          <input type="hidden" name="product" :value="params.product">
        </form>
        <p class="message" v-if="message.length">{{message}}</p>
    </div>
</template>

<script>
import { MaskInput } from 'vue-3-mask';
import DefButtonPrimary from "../Def/DefButtonPrimary/DefButtonPrimary.vue";

export default {
  name: 'ProductNotAvailable',
  components: {DefButtonPrimary, MaskInput},
  selector: '.product-not-available',
  props: ['params'],
  data() {
    return {
      message: '',
      phone: '',
      phoneEror: false,
    }
  },
  methods: {
    async handlerSubmit({target}) {
      if (this.phone.length === 19) {
        const formData = new FormData(target);
        let responseStatus = '';

        formData.append('handler', 'question.product');
        formData.append('func', 'notifyNotAvailableProduct');

        await axios.post(window.App.AJAX_DIR, formData).then((response) => {
          this.message = response.data.status === "error" ? response.data.message : response.data.data;

          responseStatus = response.data.status;
        });

        if (responseStatus === "success") {
          document.getElementsByClassName("product-not-available-form")[0].reset()
        }
      } else {
        this.message = this.params.phoneError;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.product-not-available-form{
  display: flex;
  margin-top: 20px;
}
.message {
  text-align: left;
  color: red;
  font-size: 13px;
}
.product-not-available {
    &__text{
        color: #212529;
        //font-family: Roboto;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 125% */
        margin-bottom: 18px;
    }
    .phone {
      border-radius: 9px 0 0 9px;
    }
    ::v-deep{
        .def-button-primary{
          border-radius: 0 9px 9px 0;
          height: 40px;
        }
    }
}
</style>